import { render, staticRenderFns } from "./WagesAgreement.vue?vue&type=template&id=be3e49ae&scoped=true&"
import script from "./WagesAgreement.vue?vue&type=script&lang=js&"
export * from "./WagesAgreement.vue?vue&type=script&lang=js&"
import style0 from "./WagesAgreement.vue?vue&type=style&index=0&id=be3e49ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3e49ae",
  null
  
)

export default component.exports